import React, { useState } from 'react';
import { Send } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';
import { useChat } from '../../hooks/useChat';

const InputArea = () => {
  const { theme, loading } = useAppContext();
  const { handleQuerySubmit } = useChat();
  const [input, setInput] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input.trim()) {
      handleQuerySubmit(input);
      setInput('');
    }
  };

  return (
    <div className="pt-6 pb-6 max-w-4xl mx-auto w-full">
      <form
        onSubmit={handleSubmit}
        className={`relative flex items-center gap-2 backdrop-blur-md rounded-xl p-2  border transition-colors
          ${theme === 'dark'
            ? 'bg-gray-800/70 border-gray-400'
            : 'bg-gray-100/70 border-gray-400'
          }`}
      >
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Ask me anything..."
          className={`flex-grow bg-transparent outline-none px-4 text-base
            ${theme === 'dark'
              ? 'text-gray-200 placeholder-gray-400'
              : 'text-gray-800 placeholder-gray-500'
            }`}
        />

        <button
          type="submit"
          disabled={loading || !input.trim()}
          className={`flex items-center justify-center p-2.5 
            transition-all duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500/40
            ${theme === 'dark'
              ? ' text-gray-100 '
              : ' text-gray-800 '
            }
            ${loading || !input.trim()
              ? 'opacity-50 cursor-not-allowed hover:scale-100'
              : 'hover:scale-110 hover:text-blue-600'
            }`}
        >
          {loading ? (
            <svg
              className="animate-spin h-5 w-5 text-blue-500"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              />
            </svg>
          ) : (
            <Send size={28} className="transition-transform duration-300" />
          )}
        </button>
      </form>
    </div>
  );
};

export default InputArea;